'use strict';

const placeholder = require('../../images/avatar_placeholder.jpg');
const getRect = function (crop) {
  var x1 = crop.x1;
  var y1 = crop.y1;
  var x2 = crop.x2;
  var y2 = crop.y2;

  return String(x1 + ',' + y1 + ',' + (Math.abs(x2 - x1)) + ',' + (Math.abs(y2 - y1)));
};
const getQueryString = function (params) {
  var queryParts = Object.keys(params).map(function (key) {
    return key + '=' + String(params[key]);
  });

  return '?' + queryParts.join('&');
};

function getPhotoUrl(size, isRect, crop, fit, photo, imgUrl, imgQuality, devicePixelRatio) {
  var photoPath = photo && photo.path;
  var dpr = devicePixelRatio;
  var params;
  var photoUrl;

  if (photo && photoPath) {
    if (!size || (photo.width < size[0] && photo.height < size[1])) {
      size = [photo.width, photo.height];
      dpr = 1;
    }

    params = {
      w: size[0],
      h: size[1],
      dpr: dpr,
      or: photo.angle || 0,
      q: imgQuality,
      bri: photo.brightness || 0,
      con: photo.contrast || 0,
    };

    // https://docs.imgix.com/apis/url/size/rect
    // crops a region inside an image
    if (isRect && photo.crop) {
      params.rect = getRect(photo.crop);
    }

    // https://docs.imgix.com/apis/url/size/crop
    // top, bottom, left, right, faces, and entropy
    if (crop && photo.position) {
      // TODO: check imgix params again?
      params.crop = photo.position;
    } else if (!photo.position) {
      params.crop = 'faces';
    }

    if (fit) {
      params.fit = 'crop';
    }


    photoUrl = imgUrl + photoPath.replace('{type}', 'original_') + getQueryString(params);
  } else {
    photoUrl = placeholder;
  }

  return photoUrl;
}

export default function f(config, photoSizes, deviceCapabilities) {
  'ngInject';

  var imgUrl = config.imgUrl;
  var imgQuality = config.imgQuality;
  var devicePixelRatio = (deviceCapabilities.pixelRatio >= 1.5) ? 1.5 : 1;

  return {
    scope: {
      photo: '='
    },
    template: '<img>',
    replace: true,
    link: function ($scope, $element, $attr) {
      var size = photoSizes[$attr.size];
      var isRect = $attr.hasOwnProperty('rect');
      var crop = $attr.hasOwnProperty('crop');
      var fit = $attr.hasOwnProperty('fit');
      var isDynamic = $attr.hasOwnProperty('dynamic');
      var isLazy = $attr.hasOwnProperty('lazy');
      var srcAttribute = (isLazy) ? 'data-src' : 'src';

      if (isLazy) {
        $element.addClass('lazyload');
      }

      function setPhotoUrl() {
        $attr.$set(srcAttribute, getPhotoUrl(size, isRect, crop, fit, $scope.photo, imgUrl, imgQuality, devicePixelRatio));
      }

      function setWatchers() {
        $scope.$watch('photo.crop', setPhotoUrl);
        $scope.$watch('photo.angle', setPhotoUrl);
      }

      $scope.$watch('::photo', function (photo) {
        setPhotoUrl();
        if (isDynamic && typeof photo !== 'undefined') {
          setWatchers();
        }
      });
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/directives/photo.js